// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__lxpxO","rightAdornment":"Header_rightAdornment__VBDb2"};